import React from "react";
import { useUpdateMutation } from "@supabase-cache-helpers/postgrest-react-query";
import getSupabaseBrowserClient from "../hooks/use-supabase-browser";
import { useNotifications } from "../providers/notifications";
import { useNavigate } from "react-router-dom";

export default ({
  text,
  subject,
  mutationData,
  onSuccess,
  confirmationText,
}: {
  text: string;
  subject: "venues" | "users";
  mutationData: { [key: string]: any };
  onSuccess: () => void;
  confirmationText?: string;
}) => {
  const supabase = getSupabaseBrowserClient();
  const { notify } = useNotifications();

  const { mutate, isPending } = useUpdateMutation(
    supabase.from(subject),
    ["id"],
    null,
    {
      onSuccess: () => {
        notify("Updated successfully!", "success", 3000);
        onSuccess();
      },
      onError: (error) => {
        console.error("Error while updating:", error);
        notify("Error while updating. Please try again.", "error", 3000);
      },
    }
  );

  const handleOnClick = () => {
    if (confirmationText && !window.confirm(confirmationText)) {
      return;
    }
    mutate(mutationData);
  };

  return (
    <button
      className="btn btn-xs join-item btn-info"
      disabled={isPending}
      onClick={handleOnClick}
    >
      {text}
    </button>
  );
};
